module.exports = __webpack_public_path__ + "static/img/banner-bg.f15b8715.png";